import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function LinkedinIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.29706 21H7.03057V8.97671H3.29706V21ZM5.16494 3C3.96545 3 3 3.97151 3 5.1673C3 6.36422 3.96545 7.33461 5.16494 7.33461C6.35768 7.33461 7.3265 6.36422 7.3265 5.1673C7.3265 3.97151 6.35768 3 5.16494 3ZM21.0037 14.4057V21H17.2735V15.154C17.2735 13.7588 17.2488 11.9645 15.3348 11.9645C13.3926 11.9645 13.0978 13.4849 13.0978 15.0537V21H9.37104V8.97671H12.947V10.6199H12.9988C13.4961 9.67547 14.7125 8.67804 16.5275 8.67804C20.306 8.67804 21.0037 11.1677 21.0037 14.4057Z",
    fill: "currentColor"
  }));
}